// src/pages/Login.js

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Activity, Lock, User, AlertCircle } from 'lucide-react';
import './Login.css';

export default function Login({ onLoginSuccess }) {
    const [credentials, setCredentials] = useState({ login: '', senha: '' });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.get('session_expired')) {
            setError('Sua sessão expirou. Por favor, faça login novamente.');
        }
    }, [location]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const API_URL = process.env.REACT_APP_API_URL || '';
            const response = await fetch(`${API_URL}/api/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(credentials)
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
                onLoginSuccess(data.user);
                window.location.href = '/'; // 🔄 Força um recarregamento completo da aplicação
            } else {
                setError(data.error || 'Usuário ou senha inválidos.');
            }
        } catch (err) {
            setError('Erro de conexão. Verifique se o servidor está rodando.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <div className="logo-circle">
                        <Activity size={34} color="white" strokeWidth={2.5} />
                    </div>
                    <h1>Saúde Digital</h1>
                    <p>Acesso restrito — ACS e Supervisão</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    {error && (
                        <div className="error-message">
                            <AlertCircle size={16} style={{ flexShrink: 0 }} />
                            {error}
                        </div>
                    )}

                    <div className="form-group">
                        <div className="input-icon">
                            <User size={18} />
                            <input
                                type="text"
                                name="login"
                                placeholder="Login ou CNS"
                                value={credentials.login}
                                onChange={handleChange}
                                required
                                autoComplete="username"
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="input-icon">
                            <Lock size={18} />
                            <input
                                type="password"
                                name="senha"
                                placeholder="Senha"
                                value={credentials.senha}
                                onChange={handleChange}
                                required
                                autoComplete="current-password"
                            />
                        </div>
                    </div>

                    <button type="submit" className="login-button" disabled={isLoading}>
                        {isLoading ? 'Entrando...' : 'Entrar no Sistema'}
                    </button>
                </form>

                <div className="login-divider" />
                <div className="login-footer">
                    <p>Esqueceu a senha? Contate o suporte técnico.</p>
                </div>
            </div>
        </div>
    );
}